<template>
  <div class="container-fluid">
    <div align="left">
      <el-input class="col-lg-3 col-md-4 col-sm-5  col-5" v-model="search.id" placeholder="ID"></el-input>
      <el-input class="col-lg-3 col-md-4 col-sm-5  col-5" v-model="search.city" placeholder="City"></el-input>
      <el-input class="col-lg-3 col-md-4 col-sm-5  col-5" v-model="search.user_email" placeholder="User email"></el-input>
      <el-button @click="search1()">Search</el-button>
    </div>
    <div style="margin-bottom: 6px">
      <div align="left"><b>{{total}}</b> Devices</div>
      <el-table  v-tb-height="{bottom:40,self:this}" :height="height" stripe border :data="list" empty-text="Temporarily no data">
        <el-table-column prop="device_id" label="ID" min-width="80px">
          <template slot-scope="scope">
            {{scope.row.device_id?scope.row.device_id.substring(7):''}}
          </template>
        </el-table-column>
        <el-table-column prop="device_fireware_version" label="Fireware" min-width="80px"></el-table-column>
        <el-table-column prop="device_active_datetime" label="ActiveDate"  min-width="150px">
          <template slot-scope="scope">
            {{new Date(scope.row.device_active_datetime*1000)}}
          </template>
        </el-table-column>
        <el-table-column label="bind Account" min-width="200px" >
          <template slot-scope="scope">
            <div v-for="account in scope.row.user_list">
              <a v-if="scope.row.user_list.length>1" v-on:click="toDelete(scope.row,account)"><i class="el-icon-delete delete"></i></a>{{account}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="City" min-width="150px"></el-table-column>
        <el-table-column prop="craftie_count" label="Crafties Count" min-width="100px" align="center">
          <template slot-scope="scope">
            <a v-if="scope.row.craftie_count>0" v-on:click="showCrafite(scope.row)" style="color:#409EFF">{{scope.row.craftie_count}}</a>
            <a v-else>{{scope.row.craftie_count}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="device_last_online" label="Last online Date"  min-width="150px">
          <template slot-scope="scope">
            {{new Date(scope.row.device_last_online*1000)}}
          </template>
        </el-table-column>
        <el-table-column label="operator" min-width="80px">
          <template slot-scope="scope">
            <a  v-on:click="showDetail(scope.row)"><i class="el-icon-s-order content"></i>Detail</a>
          </template>
        </el-table-column>
        <!--<el-table-column min-width="100px" label="operator">
          <template slot-scope="scope">
            <a class="el-icon-s-order" v-on:click="showContent(scope.row)">Content</a>
            <a class="el-icon-s-data" v-on:click="showUpdate(scope.row)">Update</a>
            <a class="el-icon-delete" v-on:click="doDelete(scope.row)">Delete</a>
          </template>
        </el-table-column>-->
      </el-table>
    </div>
    <div align="right">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="Device Detail"
      :visible.sync="detailflag"
      @close="detailflag=false"
      destroy-on-close
      top="5vh"
      width="60%"
    >
      <DeviceDetail v-if="detailflag" :chooseItem="chooseItem" @close="detailflag=false" @showlog="showLog"></DeviceDetail>
    </el-dialog>
    <el-dialog
      title="Device Crafties"
      :visible.sync="crafiteflag"
      @close="crafiteflag=false"
      destroy-on-close
      top="10vh"
      width="60%"
    >
      <DeviceCrafite v-if="crafiteflag" :chooseItem="chooseItem" @close="crafiteflag=false"></DeviceCrafite>
    </el-dialog>
    <el-dialog
      title="Device Log"
      :visible.sync="logflag"
      @close="logflag=false"
      destroy-on-close
      top="10vh"
      width="43%"
    >
      <DeviceLog v-if="logflag" :chooseItem="chooseItem" @close="logflag=false"></DeviceLog>
    </el-dialog>
  </div>
</template>

<script>
  import DeviceDetail from './DeviceDetail'
  import DeviceCrafite from './DevicesCrafite'
  import DeviceLog from './DeviceLog'
  export default {
    name: "Devices",
    components: {DeviceDetail,DeviceCrafite,DeviceLog},
    data() {
      return {
        height:0,
        list: [],
        search: {
          id: '',
          city:'',
          user_email:''
        },
        formData:{},
        chooseItem: null,
        isEdit: true,
        dialogName: "",
        currentPage:1,
        pageSize:20,
        total:0,
        crafiteflag:false,
        detailflag:false,
        logflag:false,
      }
    },
    created() {
      if(this.$route.query.city){
        this.search.city=this.$route.query.city
        this.search1()
      }else{
        this.getData();
      }
    },
    mounted() {
    },
    methods: {
      getData(){
        this.formData.size = this.pageSize
        this.formData.page = this.currentPage
        this.$api.rootV1.post('/web/device/list', this.formData, (res) => {
          this.list = res.data
          this.total=res.totalCount
        })
      },
      showDetail(row){
        this.detailflag=true
        this.chooseItem=row
      },
      showCrafite(row){
        this.crafiteflag=true
        this.chooseItem=row
      },
      showLog(){
        this.detailflag=false
        this.logflag=true
      },
      showUpdate() {

      },
      async toDelete(row,account) {
        this.$confirm('This operation will delete the bound account, do you want to continue?', 'prompt', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(async () => {
          this.doDelete(row,account)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'cancelled!'
          });
        });
      },
      doDelete(row,account){
        let loading = this.$util.loading()
        this.$api.rootV1.post("/web/device/cancelbind",
          {device_id:row.device_id,user_email:account},
          (res)=>{
            row.user_list=row.user_list.filter((row)=> {
              if (row==account){
                return false
              }else {
                return true
              }
            })
            this.$message({
              type: 'success',
              message: 'Unbind successfully!'
            });
            loading.close()
          },(res)=>{
            this.$message({
              type: 'error',
              message: 'Unbinding failed!'
            });
            loading.close()
          })
      },
      search1(){
        if(this.search.id==''&&this.search.city==''&& this.search.user_email==''){
          this.getData()
        }else {
          let loading = this.$util.loading()
          this.$api.rootV1.post("/web/device/get",
            {device_id:this.search.id,city:this.search.city,user_email:this.search.user_email},
            (res)=>{
              this.list=res.data
              this.total=res.data.length
              loading.close()
            })
        }
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage=val
        this.getData()
      },
      setHeight () {
        this.$nextTick(
          () => {
            if (document.documentElement.clientHeight < document.getElementById('table').offsetTop + 300) {
              this.height = 240
            } else {
              this.height = document.documentElement.clientHeight - document.getElementById('table').offsetTop - 60
            }
          }
        )
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/main/device/Devices.vue